import { render } from "./ButtonWhite.vue?vue&type=template&id=0ba23da8&scoped=true&bindings={\"outline\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./ButtonWhite.vue?vue&type=script&lang=js"
export * from "./ButtonWhite.vue?vue&type=script&lang=js"

import "./ButtonWhite.vue?vue&type=style&index=0&id=0ba23da8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ba23da8"

export default script